'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useMemo, } from 'react';
const defaultOptions = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
};
export const Datetime = forwardRef(({ date, locale = 'en-US', options, ...otherProps }, forwardedRef) => {
    const hasDateTimeStyle = useMemo(() => options?.timeStyle ?? options?.dateStyle, [options]);
    const humanDate = useMemo(() => {
        const timeDate = new Date(date);
        return new Intl.DateTimeFormat(locale, hasDateTimeStyle ? { ...options } : { ...defaultOptions, ...options }).format(timeDate);
    }, [date, hasDateTimeStyle, locale, options]);
    return (_jsx("time", { dateTime: date, ref: forwardedRef, ...otherProps, children: humanDate }));
});
